import React from "react";
import { Box, Table } from "@chakra-ui/react";
import TableColumn from "./TableColumn";
import TableRows from "./TableRows";

const TableContainer = (props) => {
  const {
    columns = [],
    rows = [],
    actions = [],
    size = "sm",
    width = "max-content",
    minWidth = "100%",
    striped = false,
    variant = "outline",
    showColumnBorder = false,
    truncateText = true,
    maxTextLength = 50,
    showTooltip = true,
  } = props;

  return (
    <Box width="100%" overflowX="auto">
      <Table.Root
        size={size}
        striped={striped}
        variant={variant}
        showColumnBorder={showColumnBorder}
        style={{ width: width, minWidth: minWidth }}
      >
        <TableColumn columns={columns} />
        <TableRows 
          columns={columns} 
          rows={rows} 
          actions={actions}
          truncateText={truncateText}
          maxTextLength={maxTextLength}
          showTooltip={showTooltip}
        />
      </Table.Root>
    </Box>

  );
};

export default TableContainer;
